import { loadI18nLanguageAsync } from '@i18n';
import siteService from "@services/siteService.js";

const state = {
  inited: false,
  services: [],
  domains: undefined,
  languages: [],
  languageDefault: undefined,
  languageUse: undefined,
  customFonts: [],
  design: undefined,
  adsMWE : true,
  limit: {
    section: null,
    slideSection: null, // ------ Include in section ------ Ex: section limit: 5, slide section limit: 1 MEAN: other section 4 + slide section 1 = 5 section
    grid: null,
    slidePage: null,
    packageID: 6,
  }
}

const getters = {
  inited: state => {
    return state.inited;
  },
  services: state => {
    return state.services;
  },
  domains: state => {
    return state.domains;
  },
  languages: state => {
    return state.languages;
  },
  languageDefault: state => {
    return state.languageDefault;
  },
  languageUse: state => {
    return state.languageUse;
  },
  customFonts: state => {
    return state.customFonts;
  },
  design: state => {
    return state.design;
  },
  adsMWE: state => {
    return state.adsMWE;
  },
  limit: state => {
    return state.limit;
  },

}

const mutations = {
  SET_INITED(state) {
    state.inited = true;
  },
  SET_SERVICES(state, { services }) {
    state.services = services
  },
  SET_DOMAINS(state, { domains }) {
    state.domains = domains
  },
  SET_LANGUAGES(state, { languages }) {
    state.languages = languages
  },
  SET_LANGUAGE_DEFAULT(state, { language }) {
    state.languageDefault = language
  },
  SET_LANGUAGE_USE(state, { language }) {
    state.languageUse = language
  },
  SET_CUSTOM_FONTS(state, { customFonts }) {
    state.customFonts = customFonts
  },
  SET_DESIGN(state, { design }) {
    state.design = design
  },
  SET_ADS_MWE(state, { adsMWE }) {
    state.adsMWE = adsMWE
  },
  SET_LIMIT(state, { limit }) {
    state.limit = limit
  }
}

const actions = {
  init: async ({ dispatch, commit }, { siteData }) => {
    const domains = siteData.domain;
    const services = siteData.services;
    const languages = siteData.languages;
    const languageDefault = Object.entries(languages).filter((arr) => arr[1].isDefault)[0][0];
    const languageUse = languageDefault;
    const customFonts = siteData.customFonts;
    const design = siteData.design;
    const adsMWE = siteData.adsMWE;
    const limit = siteData.limit;
    commit('SET_SERVICES', { services: services });
    commit('SET_DOMAINS', { domains: domains });
    commit('SET_LANGUAGES', { languages: languages });
    commit('SET_LANGUAGE_DEFAULT', { language: languageDefault });
    dispatch('setLanguageUse', { language: languageUse });
    commit('SET_INITED');
    commit('SET_CUSTOM_FONTS', { customFonts: customFonts });
    commit('SET_DESIGN', { design: design });
    commit('SET_ADS_MWE', { adsMWE: adsMWE });
    commit('SET_LIMIT', { limit: limit });
    localStorage.setItem('lastTransactionID', design.lastTransactionID)
    siteService
      .setSite({
        data: {
          actions: [
            {
              op: "replace",
              path: "/main/props/timestamp",
              value: Date.now(),
            }
          ],
          transactionID: localStorage.getItem('lastTransactionID'),
        },
      })
      .then((response) => {
        localStorage.setItem('lastTransactionID', response.transactionID)
      });
  },
  syncAdsMWE({ dispatch }) {
    dispatch('designIframe/setAdsMWE', { adsMWE: state.adsMWE }, { root: true })
  },

  setLanguageUse({ commit }, { language }) {
    loadI18nLanguageAsync(language).then(() => {
      commit('SET_LANGUAGE_USE', { language })
    });
  },
  initCustomFonts({ commit }, { customFonts }) {
    commit('SET_CUSTOM_FONTS', {customFonts: customFonts} );
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};